module.exports = __webpack_public_path__ + "static/media/logo-chubb.1530a2fb.svg";